import React from 'react';
import PropTypes, { oneOf } from 'prop-types';
import { StyledRadios, StackedIcons, Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { GENDER_VALUE } from '../../../constants/constants';
import { FORM_KEYS } from '../../../constants/formKeys';

export const PetGenderSelection = ({ petGender, formContext, isDisabled }) => {
  const petRadios = [
    {
      label: 'Male',
      value: GENDER_VALUE.MALE_GENDER_VALUE,
      labelCssClass: {
        checked: 'button primary',
        unchecked: 'button primary outline'
      },
      icon: {
        checked: (
          <StackedIcons
            customCssClass="offsetTick"
            icons={[
              <Icon
                key="icon1"
                icon="radio-unchecked"
              />,
              <Icon
                key="icon2"
                icon="tick"
                customCssClass="reveal animate-slow animate-once"
              />
            ]}
          />
        ),
        unchecked: <Icon icon="radio-unchecked" />
      }
    },
    {
      label: 'Female',
      value: GENDER_VALUE.FEMALE_GENDER_VALUE,
      labelCssClass: {
        checked: 'button primary',
        unchecked: 'button primary outline'
      },
      icon: {
        checked: (
          <StackedIcons
            customCssClass="offsetTick"
            icons={[
              <Icon
                key="icon1"
                icon="radio-unchecked"
              />,
              <Icon
                key="icon2"
                icon="tick"
                customCssClass="reveal animate-slow animate-once"
              />
            ]}
          />
        ),
        unchecked: <Icon icon="radio-unchecked" />
      }
    }
  ];

  return (
    <>
      <h3>Pet gender</h3>
      <StyledRadios
        fieldFormContext={formContext}
        groupName="petGender"
        name={FORM_KEYS.PET_GENDER}
        value={petGender}
        disabled={isDisabled}
        customCssClass={isDisabled ? 'disabled' : ''}
        radioInputs={petRadios}
        required
      />
    </>
  );
};

PetGenderSelection.propTypes = {
  petGender: oneOf([GENDER_VALUE.MALE_GENDER_VALUE, GENDER_VALUE.FEMALE_GENDER_VALUE]),
  isDisabled: PropTypes.bool,
  formContext: PropTypes.shape({
    petGender: oneOf([GENDER_VALUE.MALE_GENDER_VALUE, GENDER_VALUE.FEMALE_GENDER_VALUE])
  })
};
